import { z } from 'zod';
import { createErrorHandler } from './helpers/error-handler';
export const dateValidator = ({ requiredError, requireFutureDate, }) => {
    let validator = z.coerce.date({
        error: createErrorHandler(requiredError),
    });
    if (requireFutureDate) {
        validator = validator.refine((date) => date > new Date(), {
            error: requireFutureDate.error,
        });
    }
    return validator;
};
